import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function RequireAuth({ children }) {
  const isLoggedIn =
    typeof window !== "undefined" && sessionStorage.getItem("isLoggedIn") === "true";
  const token =
    typeof window !== "undefined" && sessionStorage.getItem("access_token");
  const location = useLocation();

  if (!isLoggedIn || !token) {
    // ใช้ sessionStorage แทน localStorage เพื่อความปลอดภัย (ลบอัตโนมัติเมื่อปิด tab)
    sessionStorage.setItem("postLoginRedirect", location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }
  return children;
}
